import {Col, Container, Form, Row} from "react-bootstrap";
import React, {useContext, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "context/action";
import {API_CALL_ERR_MSG} from "utils/ConstantsMsg";
import {ToastContext} from "context/Toast";
import {swiftWiresRefTypesJSON} from "../../pages/admin/swiftwires/SwiftWiresFilter";

const defaultRefType = swiftWiresRefTypesJSON.find(item => item.id !== '')?.id || '';
const refTypeOptions = swiftWiresRefTypesJSON
    .filter(item => item.id !== '')
    .map(item => <option key={item.id} value={item.id}>{item.name}</option>);

export default function WireApproveModal(props) {

    const {setShowApprove, setShow, gridApi, showReferenceFields} = props
    const {isDesktop} = useWindowDimensions();
    const {handleApprove, isValidApprover} = useContext(ActionPanelContext);
    const [comment, setComment] = useState('');
    const [approving, setApproving] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [refType, setRefType] = useState(defaultRefType);
    const [reference, setReference] = useState('');
    const {error, success, alert} = useContext(ToastContext);


    const handleOnChange = (param) => {
        setComment(param.target.value)
    }

    const handleOnApproveClicked = () => {

        if(gridApi.getSelectedRows().length === 0){
            alert("Select an item to approve")
            return
        }

        const onSuccess = () => {
            setApproving(false);
            setShow(false);
            setShowApprove(false);
            success("Item/s approved successfully")

        }

        const onError = (err) => {
            let errMsg = API_CALL_ERR_MSG
            const responseData = err?.response?.data
            if (responseData) {
                if (typeof responseData === 'string') {
                    errMsg = responseData
                } else if (responseData.message) {
                    errMsg = responseData.message
                } else if (responseData.error) {
                    errMsg = responseData.error
                }
                else if (typeof responseData === 'object') {
                    const fieldNames = Object.keys(responseData)
                    if (fieldNames.length > 0) {
                        const firstField = fieldNames[0]
                        errMsg = responseData[firstField]
                    }
                }
            }

            error(errMsg)

            setApproving(false);
        }

        const approvalReference = showReferenceFields ? `/${refType}/${reference}` : null;
        setApproving(true);

        handleApprove(comment, onSuccess, onError, approvalReference);
    }

    const getRestrictedItems = () => {
        return gridApi.getSelectedRows().filter(row => !row.isValidApprover).map((row, i) => getRowData(row, i))
    }

    const getRowData = (row, i) => {
        return(<>
            <span>{i+1}) Template:{row.templateName}, Manager:{row.managerNameShort}, Account:{row.cdClient}, Status:{row.status} </span><br/>
        </>)
    }

    return (<div className='modal-container'>
        {!isValidApprover ?
            <Container fluid className={"my-3 my-md-0"}>
                <Row>
                    <Col md={12}>
                        <h4 style={{textAlign: isDesktop?'left':'center'}}>The following items cannot be approved:</h4>
                    </Col>
                    <Col>
                        {getRestrictedItems()}
                    </Col>
                </Row>
            </Container>
        :
        <Container fluid className={"my-3 my-md-0"}>

            <Row>
                <Col md={12}>
                    <h4 style={{textAlign: isDesktop?'left':'center'}}>{showReferenceFields ? 'Are you sure you want to complete the wire transaction?' : 'Are you sure you want to approve this?'}</h4><br/>
                </Col>
            </Row>
            {showReferenceFields && <Row className={"pr-4"}>
                <Col md={6} xs={12}>
                    <Form.Group controlId="formGridRefType" className={'td-select'}>
                        <Form.Label className="filter-input-label">Ref Type:</Form.Label>
                        <Form.Control as="select" name="refType"
                                      value={refType}
                                      onChange={(e) => {
                                          setRefType(e.target.value);
                                          if (formErrors.refType) {
                                              setFormErrors({...formErrors, refType: null});
                                          }
                                      }}
                                      isInvalid={!!formErrors.refType}>
                            {refTypeOptions}
                        </Form.Control>
                        <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.refType}</b></Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                    <Form.Group controlId="formGridReference">
                        <Form.Label className="filter-input-label">TD Reference:</Form.Label>
                        <Form.Control
                            placeholder="" name="reference"
                            value={reference}
                            onChange={(e) => {
                                setReference(e.target.value);
                                if (formErrors.reference) {
                                    setFormErrors({...formErrors, reference: null});
                                }
                            }}
                            isInvalid={!!formErrors.reference}
                        />
                        <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.reference}</b></Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>}
            {!showReferenceFields && <Row>
                <Col md={12} className='pb-2'>
                    <Form.Label className="filter-input-label pb-2">Add Comments</Form.Label>
                    <Form.Group controlId="comment">
                        <Form.Control as='textarea' rows={5} placeholder="Leave a comment" disabled={approving}
                                      name={"comment"} value={comment}
                                      onChange={handleOnChange}/>
                    </Form.Group>
                </Col>
            </Row>}
            <Row className={"justify-content-end pr-4"}>
                <Col md={6} xs={12} sm={12}>
                    <button disabled={approving} className='btn btn-block td-btn-secondary-clear' href="#" onClick={() => {
                        setShow(false);
                        setShowApprove(false);
                    }}>Cancel
                    </button>
                </Col>
                <Col md={6} xs={12} sm={12}>
                    <button disabled={approving} className={'btn btn-block td-btn-primary-light'} href="#" onClick={handleOnApproveClicked}>Approve
                    </button>
                </Col>
            </Row>
        </Container> }
    </div>)
}

WireApproveModal.defaultProps = {
    showReferenceFields: false,
}
